import React, { createContext, useContext, useMemo, useState } from 'react';
import { TDR } from 'tdr-common';

/**
 * TableSelectionContext manages the currently selected/highlighted table in the 3D environment.
 * This is used for Right→Left sync (3D camera → carousel highlight).
 * Left→Right sync (carousel click → 3D) uses URL navigation instead.
 */
type TableSelectionContextType = {
	globalNearestTable: TDR.Table;
	setGlobalNearestTable: React.Dispatch<React.SetStateAction<TDR.Table>>;
	firstAvailableTable: TDR.Table;
	setFirstAvailableTable: React.Dispatch<React.SetStateAction<TDR.Table>>;
}

const TableSelectionContext = createContext<TableSelectionContextType>({} as TableSelectionContextType);

export const useTableSelectionContext = () => useContext(TableSelectionContext);

// Legacy export for backward compatibility during migration
export const useMaterialInfoContext = useTableSelectionContext;

export const TableSelectionProvider = ({ children }: any) => {
	const [globalNearestTable, setGlobalNearestTable] = useState<TDR.Table>();
	const [firstAvailableTable, setFirstAvailableTable] = useState<TDR.Table>();

	// Memoize context value to prevent unnecessary re-renders
	const value = useMemo(() => ({
		globalNearestTable,
		setGlobalNearestTable,
		firstAvailableTable,
		setFirstAvailableTable
	}), [globalNearestTable, firstAvailableTable]);

	return (
		<TableSelectionContext.Provider value={value}>
			{children}
		</TableSelectionContext.Provider>
	);
};
